import PropTypes from 'prop-types'
import { Component } from 'react'

import Breadcrumbs from '../../../Header/breadcrumbs'

import './styles.scss'

export class NavBar extends Component {
  render () {
    const { children, /* breadCrumbs, */ logo } = this.props

    return (
      <nav id='scrollTop'>
        <div className='flex flex-row gap-2 px-5 py-1.5 items-center'>
          <div className='mt-1.5'>{logo}</div>
          <Breadcrumbs />
        </div>
        <div className='nav-section'>
          <div className='items'>{children}</div>
        </div>
      </nav>
    )
  }
}

NavBar.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.node,
  noShadow: PropTypes.bool
}
